/* Sticky Add to cart bar. Product pages only, loaded from _meta-tags.liquid.

   Why: the Cashier Station Lights product has 8 Webyze option groups. Measured
   at 375x812, the real Add to cart button sits at y=1612 - just under two full
   screens down - because the gallery and title already put the price at y=877.
   Tightening the option controls recovered 51px; it cannot fix the rest.

   This mirrors rather than replaces. The sticky button forwards a real click to
   button[data-to-cart], so BOTH the theme's own handler and Webyze's hook run
   exactly as they would if the customer had scrolled back up. Nothing about the
   cart path changes, which matters because that path was the source of the
   undercharging bug.

   The price is mirrored live from .#price-value, the same element Webyze
   updates as options are chosen, so the sticky bar shows the CONFIGURED total,
   not the base price.

   Validation: Webyze blocks submit on an empty required field by appending a
   .webyze-ilpo-alert-error div to <body> for 4s. Clicked from the sticky bar
   the customer would see that message but not the field it refers to, so a
   blocked submit scrolls the options block back into view. */
(function () {
  'use strict';
  if (window.__tccStickyAtc) return;
  window.__tccStickyAtc = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var real = document.querySelector('button[data-to-cart]');
    if (!real) return;

    var priceEl = document.querySelector('.\\#price-value');
    var titleEl = document.querySelector('h1');
    var optionsForm = document.querySelector('.webyze-infinitelivepreviewoptions-form');

    /* The theme's button holds TWO labels inside <buy-with-counter> and toggles
       them with the `hidden` attribute: "Add to cart" and "Add N items to
       cart". Reading real.textContent returns both concatenated, so take the
       first child that is not hidden. */
    function currentLabel() {
      var counter = real.querySelector('buy-with-counter');
      if (counter) {
        for (var i = 0; i < counter.children.length; i++) {
          var c = counter.children[i];
          if (!c.hasAttribute('hidden')) {
            var t = c.textContent.replace(/\s+/g, ' ').trim();
            if (t) return t;
          }
        }
      }
      return 'Add to cart';
    }

    function galleryImg() {
      return document.querySelector('.\\#product-gallery-stage-inner .swiper-slide-active .\\#media-image')
          || document.querySelector('.\\#product-gallery-stage-inner img');
    }

    var bar = document.createElement('div');
    bar.className = 'tcc-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var img = document.createElement('img');
    img.className = 'tcc-sticky-atc__img';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');

    var text = document.createElement('div');
    text.className = 'tcc-sticky-atc__text';
    var titleOut = document.createElement('span');
    titleOut.className = 'tcc-sticky-atc__title';
    var priceOut = document.createElement('span');
    priceOut.className = 'tcc-sticky-atc__price';
    text.appendChild(titleOut);
    text.appendChild(priceOut);

    var btn = document.createElement('button');
    btn.className = 'tcc-sticky-atc__btn';
    btn.type = 'button';

    var inner = document.createElement('div');
    inner.className = 'tcc-sticky-atc__inner';
    inner.appendChild(img);
    inner.appendChild(text);
    inner.appendChild(btn);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    function sync() {
      var g = galleryImg();
      var src = g ? (g.currentSrc || g.src) : '';
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.style.display = src ? '' : 'none';

      if (titleEl) titleOut.textContent = titleEl.textContent.trim();
      if (priceEl) priceOut.textContent = priceEl.textContent.trim();

      btn.textContent = currentLabel();
      btn.disabled = !!real.disabled;
      btn.setAttribute('aria-disabled', real.disabled ? 'true' : 'false');
    }
    sync();

    /* Webyze rewrites the price node as options change; the theme swaps the
       button label for sold-out / loading states. Watch both. */
    if (window.MutationObserver) {
      if (priceEl) {
        new MutationObserver(sync).observe(priceEl, {
          childList: true, characterData: true, subtree: true
        });
      }
      new MutationObserver(sync).observe(real, {
        childList: true, characterData: true, subtree: true, attributes: true,
        attributeFilter: ['disabled', 'class', 'hidden']
      });
    }

    /* Show only once the real button has been scrolled PAST (top < 0), never
       while it is still below the fold on the way down. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      }, { threshold: 0 }).observe(real);
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      sync();
      real.click();

      /* If Webyze rejected the submit, the alert it shows refers to a field the
         customer cannot see from down here. Take them to it. */
      var deadline = Date.now() + 900;
      (function watch() {
        if (document.querySelector('.webyze-ilpo-alert-error')) {
          var target = optionsForm || real;
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center'
          });
          return;
        }
        if (Date.now() < deadline) requestAnimationFrame(watch);
      })();
    });
  });
})();
